import { useMemo } from 'react';
import { AgentsApi, AlertsApi, DashboardsApi, EventsApi, HealthApi, InstancesApi } from '../gen/openapi';
import { ChatApi } from '../gen/openapi/apis/ChatApi';
import { Configuration } from '../gen/openapi/runtime';
import { useApiConfig } from './useApiConfig';

interface UseApiClientOptions {
  baseURL?: string;
  timeout?: number;
  additionalHeaders?: Record<string, string>;
}

export const useApiClient = (options: UseApiClientOptions = {}) => {
  const config = useApiConfig(options);

  const apiClient = useMemo(() => {
    const apiConfiguration = new Configuration({
      basePath: config.baseURL,
      headers: config.headers,
    });

    return {
      agents: new AgentsApi(apiConfiguration),
      alerts: new AlertsApi(apiConfiguration),
      chat: new ChatApi(apiConfiguration),
      config: apiConfiguration,
      dashboards: new DashboardsApi(apiConfiguration),
      events: new EventsApi(apiConfiguration),
      health: new HealthApi(apiConfiguration),
      instances: new InstancesApi(apiConfiguration),
    };
  }, [config.baseURL, config.headers]);

  return apiClient;
};

// Hook for getting the base configuration
export const useApiConfiguration = (options?: UseApiClientOptions) => {
  const config = useApiConfig(options);

  return useMemo(() => {
    return new Configuration({
      basePath: config.baseURL,
      headers: config.headers,
    });
  }, [config.baseURL, config.headers]);
};
